<template>
  <v-layout justify-space-around wrap row>
    <v-flex xs12 sm4 scrollDesign style="max-height: 55vh">
      <v-slide-x-transition mode="out-in">
        <v-list subheader two-line>
          <v-subheader key="subheader">
            {{ $t('surveys.create_survey.students_b') }}
          </v-subheader>
          <draggable
            :list="list"
            group="elements"
            class="list-group"
            draggable=".item"
          >
            <v-slide-y-transition class="two-line subheader" group>
              <v-list-tile
                avatar
                class="pa-2 mb-3 elevation-1 grey lighten-5 list-group-item item"
                style="border-radius: 5px"
                v-for="element in list"
                :key="element.id"
              >
                <v-list-tile-avatar>
                  <v-img
                    :src="require('@/assets/panel/home/SKLB-Alumnos.png')"
                  />
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title
                    v-text="element.firstName + ' ' + element.lastName"
                  />
                  <v-list-tile-sub-title
                    v-text="
                      element.level.typeLevel +
                      ' ' +
                      element.gg.grade +
                      ' ' +
                      element.gg.group
                    "
                  />
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile
                avatar
                class="pa-2 mb-3 list-group-item item"
                style="border-radius: 5px"
                :key="0"
                v-if="list.length === 0 && selectedList.length === 0"
              >
                <v-list-tile-content>
                  <v-list-tile-title
                    style="font-size: 12px; color: rgba(0, 0, 0, 0.54)"
                    >No se han encontrado resultados</v-list-tile-title
                  >
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile
                avatar
                class="pa-2 mb-3 list-group-item item"
                style="border-radius: 5px"
                color="primary"
                :key="-1"
              >
                <v-list-tile-content right>
                  <v-list-tile-content>
                    <v-btn
                      flat
                      color="primary"
                      small
                      @click="viewMore"
                      v-if="showBtnScroll"
                      >Buscar más</v-btn
                    >
                    <v-list-tile-title
                      style="font-size: 12px; color: rgba(0, 0, 0, 0.54)"
                      v-else
                      >Todos los resultados fueron mostrados</v-list-tile-title
                    >
                  </v-list-tile-content>
                </v-list-tile-content>
              </v-list-tile>
            </v-slide-y-transition>
          </draggable>
        </v-list>
      </v-slide-x-transition>
    </v-flex>
    <v-flex xs6>
      <v-list subheader>
        <v-subheader key="subheader">
          {{ $t('surveys.create_survey.added_students') }}
        </v-subheader>
        <draggable
          group="elements"
          class="list-group"
          :list="selectedList"
          draggable=".item"
        >
          <v-slide-y-transition class="two-line subheader" group>
            <v-list-tile
              avatar
              class="pa-2 mb-3 elevation-1 grey lighten-5 list-group-item item"
              style="border-radius: 5px"
              v-for="element in selectedList"
              :key="element.id"
            >
              <v-list-tile-avatar>
                <v-img :src="require('@/assets/panel/home/SKLB-Alumnos.png')" />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title
                  v-text="element.firstName + ' ' + element.lastName"
                />
                <v-list-tile-sub-title
                  v-text="
                    element.level.typeLevel +
                    ' ' +
                    element.gg.grade +
                    ' ' +
                    element.gg.group
                  "
                />
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              avatar
              class="pa-2 mb-3 list-group-item item"
              style="border-radius: 5px"
              :key="0"
            >
              <v-list-tile-avatar>
                <v-icon color="primary" large>add</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ $t('surveys.create_survey.drag_students') }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-slide-y-transition>
        </draggable>
      </v-list>
    </v-flex>
  </v-layout>
</template>

<script>
import draggable from 'vuedraggable'
export default {
  components: {
    draggable,
  },
  props: ['value', 'array', 'showBtnScroll'],
  watch: {
    array() {
      this.list = this.array
    },
    value() {
      this.selectedList = this.value
    },
    selectedList() {
      this.$emit('input', this.selectedList)
    },
  },
  mounted() {
    console.log(this.array)
    this.list = this.array
    this.selectedList = this.value
    this.$forceUpdate()
  },
  methods: {
    viewMore() {
      this.$emit('viewMore')
    },
  },
  data: () => ({
    list: [],
    selectedList: [],
  }),
}
</script>

<style></style>
